import React from 'react';
import { FieldViewLogo, LogoType, Button, ButtonFill, ComponentSize, Typography, TypographyVariant } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import styles from './styles.css';

export const ErrorFallback = () => {
  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <div className={styles.container}>
      <div className={styles.centeredContainer}>
        <FieldViewLogo
          type={LogoType.COLORED}
          size={ComponentSize.Lg}
          testId='error-fallback-logo'
        />
      </div>
      <Typography variant={TypographyVariant.Heading} size={ComponentSize.Lg} testId="error-fallback-title" className={styles.centeredContainer}>
        {getMessage('pluginLoad.error')}
      </Typography>
      <div className={styles.centeredContainer}>
        <Button fill={ButtonFill.Solid} onClick={handleRefresh} testId="error-fallback-refresh">{getMessage('common.refresh')}</Button>
      </div>
    </div>
  );
};
